import React, { useState } from 'react'
import Header from '../../layouts/Header'

const AssetStockTransfer = () => {

    const currentSkin = localStorage.getItem('skin-mode') ? 'dark' : '';
    const [skin, setSkin] = useState(currentSkin);

    return (
        <React.Fragment>
            <Header onSkin={setSkin} />
            <div className="main main-app p-3 p-lg-4">
                <div>AssetStockTransfer</div>
            </div>
        </React.Fragment>
    )
}

export default AssetStockTransfer;